import { actions, actionTypes, selectors } from 'data'
import { notifyError, notifySuccess } from 'data/App/sagas'
import { UserSettingsType } from 'data/Auth/types'
import { PreferencesFormType } from 'data/types'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { saveSettings } from 'services/api/user'
import { Response } from 'utils/fetchApi'

const submit = function* () {
  const form: PreferencesFormType = yield select(selectors.preferences.getValues)
  if (!form) return

  const settings: Partial<UserSettingsType> = {
    localCurrency: form.localCurrency
  }

  const prevCurrency = yield select(selectors.auth.getLocalCurrency)
  const prevSettings: Partial<UserSettingsType> = {
    localCurrency: prevCurrency
  }

  const data: Response<void> = yield call(saveSettings, settings)
  yield put(
    actions.auth.localSettings.writeSettings({
      orderFilledSound: form.orderFilledSound
    })
  )
  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
  } else {
    yield put(actions.auth.setUserSettings(prevSettings, settings))
    yield call(notifySuccess, 'OK_SAVE_PREFERENCES')
  }
}

export default function* preferencesMain() {
  yield takeEvery(actionTypes.preferences.SUBMIT, submit)
}
